import apiCall from '@/repository'

class UserService {
    baseUrl = '/v1/users';

    getUsers = (filters = {}, page = 1, pagelen = 20) => {
        const offset = (page === 1) ? 0 : pagelen * (page - 1);
        const params = {
            pagelen,
            offset,
            ...filters
        };

        return apiCall.get(`${this.baseUrl}`, { params });
    }

    getUserById = (id) => {
        return apiCall.get(`${this.baseUrl}/${id}`);
    }

    banUser = (id) => {
        return apiCall.post(`${this.baseUrl}/${id}/ban`, {});
    }

    unbanUser = (id) => {
        return apiCall.post(`${this.baseUrl}/${id}/unban`, {});
    }

    changeUserRole = (id, role) => {
        return apiCall.post(`${this.baseUrl}/${id}/role`, { role });
    }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/user.js